import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step3 } from '../../../../shared/models/component-messages/mapaRE/step3';
import { CTRL_175 } from '../../../validators/175/ctrl175';
import { CTRL_176 } from '../../../validators/176/ctrl176';
import { TypeVoie } from '../models/TypeVoie';
import { MapaREControlNames } from '../services/mapaREControleNames';
@Component({
  selector: 'app-type-voie',
  templateUrl: './type-voie.component.html'
})
export class TypeVoieComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeVoie';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	@Input() voie: TypeVoie;
  @Input() rule : string;
  @Input() errorMessage : string;

  public rg1 = CTRL_176.id + '_1';
  public rg2 = CTRL_175.id + '_1';

  public step3 = new Step3();
  constructor() { }

  public ngOnInit() {
    this.parentForm.addControl(this.getStepId() + this.rg1, new FormControl({ rgCtrls: MapaREControlNames.getCtrl_176Names_json() }));
    this.parentForm.addControl(this.getStepId() + this.rg2, new FormControl({ rgCtrls: MapaREControlNames.getCtrl_175Names_json() }));
   
    if (!this.voie) {
      this.voie = new TypeVoie();
    }
  }

  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  } 

  getStepId() {
		return this.uid.substring(0, this.uid.indexOf("SepSep"));
	}
  
}

